import { getEntries } from 'services/content';
import { normalizeLocale } from 'services/locale';

export const LOAD_RESOURCE = 'LOAD_RESOURCE';

const defaultState = {};

export default function resource(state = defaultState, action) {
  switch (action.type) {
    case LOAD_RESOURCE:
      return action.payload;
    default:
      return state;
  }
}

export function loadResource(locale) {
  return dispatch => {
    return getEntries({ content_type: 'site', locale: normalizeLocale(locale) }).then(function(response) {
      dispatch({
        type: LOAD_RESOURCE,
        payload: response.data.items[0].fields
      });
    });
  };
}
